import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  className: string
}

// The red mark for something unread. Placement is the caller's: pass a class
// that positions it, the dot only knows its own colour and shape.
export const UnreadDot: React.FC<Props> = ({ className }) => (
  <span className={clsJoin(css.unread_dot, className)} data-unread="true" />
)
